const Jobs = [
  {
    Title: "1. System Administrator & IT Support",
    Description:
      "We are looking for a System Administrator & IT Support to maintain and upgrade our software, hardware and networks.You’re the key contact for 1000+ employees on a daily basis (400+ in Louvain-La-Neuve and 600+ worldwide):In conclusion, your tasks are not limited to maintenance, and repair, but also any IT request that will help employees to work in an optimal working environment. You work independently and autonomously so resourcefulness is a necessary skill",
    Opening: "",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "2. Account Manager",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "10 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "3. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "4. System Administrator & IT Support",
    Description:
      "We are looking for a System Administrator & IT Support to maintain and upgrade our software, hardware and networks.You’re the key contact for 1000+ employees on a daily basis (400+ in Louvain-La-Neuve and 600+ worldwide):In conclusion, your tasks are not limited to maintenance, and repair, but also any IT request that will help employees to work in an optimal working environment. You work independently and autonomously so resourcefulness is a necessary skill",
    Opening: "25 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "5. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "6. System Administrator & IT Support",
    Description:
      "We are looking for a System Administrator & IT Support to maintain and upgrade our software, hardware and networks.You’re the key contact for 1000+ employees on a daily basis (400+ in Louvain-La-Neuve and 600+ worldwide):In conclusion, your tasks are not limited to maintenance, and repair, but also any IT request that will help employees to work in an optimal working environment. You work independently and autonomously so resourcefulness is a necessary skill",
    Opening: "25 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "7. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "8. System Administrator & IT Support",
    Description:
      "We are looking for a System Administrator & IT Support to maintain and upgrade our software, hardware and networks.You’re the key contact for 1000+ employees on a daily basis (400+ in Louvain-La-Neuve and 600+ worldwide):In conclusion, your tasks are not limited to maintenance, and repair, but also any IT request that will help employees to work in an optimal working environment. You work independently and autonomously so resourcefulness is a necessary skill",
    Opening: "25 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "9. System Administrator & IT Support",
    Description:
      "We are looking for a System Administrator & IT Support to maintain and upgrade our software, hardware and networks.You’re the key contact for 1000+ employees on a daily basis (400+ in Louvain-La-Neuve and 600+ worldwide):In conclusion, your tasks are not limited to maintenance, and repair, but also any IT request that will help employees to work in an optimal working environment. You work independently and autonomously so resourcefulness is a necessary skill",
    Opening: "25 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "10. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "11. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "12. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "13. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "14. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "15. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "16. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "17. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "18. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "19. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "20. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "21. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "22. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "23. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "24. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "25. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "26. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "27. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "28. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "29. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "30. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
  {
    Title: "31. Business Analyst",
    Description:
      "Handle a portfolio of 200+ customers, ranging from start ups to large companies. Use your business understanding and commercial skills to retain and expand you client base.",
    Opening: "20 open positions",
    Location: "Louvain-La-Neuve",
    Department: "Research & Development",
  },
];

export default Jobs;
